import { render, staticRenderFns } from "./termManage.vue?vue&type=template&id=5459440e&scoped=true"
import script from "./termManage.vue?vue&type=script&lang=js"
export * from "./termManage.vue?vue&type=script&lang=js"
import style0 from "./termManage.vue?vue&type=style&index=0&id=5459440e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5459440e",
  null
  
)

export default component.exports